import { createContext } from 'react';

const imageContext = createContext();

export default imageContext;
